<template>
  <md-card
    class="md-card-stats col-3"
    :class="selectedClass ? 'selected' : ''"
    style="
      cursor: pointer;
      justify-content: center;
      margin: 10px;
      padding: 0;
      height: 185px;
    "
  >
    <div
      style="
        width: 100%;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
      "
      @click="(event) => emitSelectMediaFile(event, item)"
    >
      <img
        v-if="type == 'image'"
        style="
          object-fit: contain;
          display: block;
          max-height: 100%;
          max-width: 100%;
        "
        :src="'data:image/' + item.extension + ';base64,' + item.image"
        alt=""
      />
      <i
        v-else-if="type == 'document'"
        class="document-icon"
        :class="documentClass"
      ></i>
    </div>
    <div style="margin-top: 15px">
      <p style="text-align: center">{{ item.caption }}</p>
    </div>
  </md-card>
</template>
<script>
export default {
  name: "mediaFile",
  props: ["item", "itemTemplateProps"],

  data() {
    return {
      selectedClass: false,
      imageExtensions: ["jpg", "jpeg", "png"],
      audioExtensions: ["wav", "mp3"],
      videoExtensions: ["mp4", "flv", "3gp", "avi", "wmv", "vob"],
      documentExtensions: ["pptx", "docx", "doc", "pdf"],
      type: null,
      documentClass: null,
    };
  },
  created: function () {
    this.setFormat();
  },
  components: {},
  methods: {
    emitSelectMediaFile(event, mediaFile) {
      this.selectedClass = true;
      this.$emit("event", { name: "selectMediaFile", payload: mediaFile });
      event.preventDefault();
    },
    setFormat() {
      if (this.imageExtensions.includes(this.item.extension)) {
        this.type = "image";
      } else if (this.videoExtensions.includes(this.item.extension)) {
        this.type = "video";
      } else if (this.audioExtensions.includes(this.item.extension)) {
        this.type = "audio";
      } else if (this.documentExtensions.includes(this.item.extension)) {
        if (this.item.extension == "pdf") {
          this.documentClass = "fa fa-file-pdf";
        } else if (this.item.extension == "pptx") {
          this.documentClass = "fa fa-file-powerpoint";
        } else if (
          this.item.extension == "docx" ||
          this.item.extension == "doc"
        ) {
          this.documentClass = "fa fa-file-word";
        } else if (
          this.item.extension == "docx" ||
          this.item.extension == "doc"
        ) {
          this.documentClass = "fa fa-file-word";
        }
        this.type = "document";
      }
    },
  },
  watch: {
    itemTemplateProps() {
      if (!this.itemTemplateProps) {
        this.selectedClass = false;
        return;
      }
      if (this.itemTemplateProps.id === this.item.id) {
        this.selectedClass = true;
      } else {
        this.selectedClass = false;
      }
    },
  },
};
</script>
<style>
.selected {
  border: solid;
  border-color: #8cc63f;
}
.document-icon {
  color: #ff4f33;
  font-size: 110px;
}
</style>



// WEBPACK FOOTER //
// resources/js/pages/Layouts/Items/mediaFile.vue